// extracted by mini-css-extract-plugin
export var equalColumn = "_gs-0";